import { useGetSupportInformation } from "../api/get-support-info";

export default function ContactInformation() {

	const supportInfo = useGetSupportInformation();

	return (
		<div className={'block-center'}>
			<div>
				<div className={'title'}>Contact Information</div>
				<div className={'text-block'}>
					<div className='help-text'>
						<i className='dx-icon-Inscyth-Phone'></i>
						{supportInfo.data?.supportPhone ?? ''}
					</div>
					{
						!!supportInfo.data?.supportEmail &&
						<div className='help-text'>
							<i className='dx-icon-Inscyth-Email'></i>
							<a href={'mailto:' + supportInfo.data.supportEmail}>{supportInfo.data.supportEmail}</a>
						</div>
					}
				</div>
			</div>
		</div>
	)
} 
